import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { EngineAtomSearchSchema } from '../-shared/engine-atom-search-schema';

export const Route = createFileRoute('/_staff/payroll-engine/_layout/items/')({
  validateSearch: zodValidator(EngineAtomSearchSchema),
});
